(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gallery-faq-section')) {
  customElements.define('gallery-faq-section', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const gallery = this.querySelector('.gf-gallery');
      const slides = gallery ? Array.from(gallery.children) : [];
      const previous = this.querySelector('[data-gf-prev]');
      const next = this.querySelector('[data-gf-next]');
      const nearestIndex = () => {
        if (!gallery || !slides.length) return 0;
        const bounds = gallery.getBoundingClientRect();
        const rtl = getComputedStyle(gallery).direction === 'rtl';
        const edge = rtl ? 'right' : 'left';
        let nearest = 0;
        let distance = Infinity;
        slides.forEach((slide, index) => {
          const delta = Math.abs(slide.getBoundingClientRect()[edge] - bounds[edge]);
          if (delta < distance) { distance = delta; nearest = index; }
        });
        return nearest;
      };
      const update = () => {
        const index = nearestIndex();
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
        const image = slides[index] && slides[index].querySelector('.gf-image');
        const height = image ? image.getBoundingClientRect().height : slides[index]?.getBoundingClientRect().height;
        if (height) gallery.parentElement.style.setProperty('--gf-controls-top', `${height / 2}px`);
      };
      const goTo = (index, instant = false) => {
        if (!gallery || !slides.length) return;
        const slide = slides[Math.max(0, Math.min(index, slides.length - 1))];
        const edge = getComputedStyle(gallery).direction === 'rtl' ? 'right' : 'left';
        const left = slide.getBoundingClientRect()[edge] - gallery.getBoundingClientRect()[edge];
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        gallery.scrollBy({ left, behavior: instant || reduceMotion ? 'instant' : 'smooth' });
      };
      const onPrevious = () => goTo(nearestIndex() - 1);
      const onNext = () => goTo(nearestIndex() + 1);
      const onKey = (event) => {
        if (event.target !== gallery) return;
        const rtl = getComputedStyle(gallery).direction === 'rtl';
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(nearestIndex() + ((event.key === 'ArrowRight') !== rtl ? 1 : -1));
        }
      };
      const onBlockSelect = (event) => {
        if (!(event.target instanceof Element)) return;
        const faq = event.target.closest('.gf-faq');
        if (faq && this.contains(faq)) faq.open = true;
        const index = slides.indexOf(event.target.closest('.gf-item'));
        if (index >= 0) goTo(index, true);
      };
      if (previous) previous.addEventListener('click', onPrevious);
      if (next) next.addEventListener('click', onNext);
      if (gallery) {
        gallery.addEventListener('scroll', update, { passive: true });
        gallery.addEventListener('keydown', onKey);
      }
      this.addEventListener('shopify:block:select', onBlockSelect);
      const observer = gallery ? new ResizeObserver(update) : null;
      if (observer) {
        observer.observe(gallery);
        slides.forEach(slide => {
          const image = slide.querySelector('.gf-image');
          if (image) observer.observe(image);
        });
      }
      update();
      this.cleanup = () => {
        if (previous) previous.removeEventListener('click', onPrevious);
        if (next) next.removeEventListener('click', onNext);
        if (gallery) {
          gallery.removeEventListener('scroll', update);
          gallery.removeEventListener('keydown', onKey);
        }
        this.removeEventListener('shopify:block:select', onBlockSelect);
        if (observer) observer.disconnect();
      };
    }
    disconnectedCallback() {
      if (this.cleanup) this.cleanup();
      this.cleanup = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
